import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase/config';

// Firebase-klienten avbryter anropet efter 70 s som standard, oavsett vad
// molnfunktionen har för timeoutSeconds. Ett stort CV (13 sidor, 18 uppdrag)
// tar längre än så att analysera och föll tidigare på "deadline-exceeded" i
// webbläsaren långt innan servern hunnit svara. Håll värdet i synk med
// timeoutSeconds för callClaude i functions/index.js.
const CALL_TIMEOUT_MS = 540000;

const callClaudeFn = httpsCallable(functions, 'callClaude', { timeout: CALL_TIMEOUT_MS });

/**
 * Proxy för Claude API — anropar server-side Cloud Function i stället för direkt från webbläsaren.
 * Returnerar samma struktur som Anthropic API: { content: [{ text: string }] }
 *
 * output_config är valfritt och används för structured outputs:
 *   output_config: { format: { type: 'json_schema', schema: { ... } } }
 * Då garanterar API:t giltig JSON i första textblocket och man slipper
 * plocka bort ```json-staket manuellt.
 */
export async function callClaude({ model, system, messages, max_tokens, output_config }) {
  const result = await callClaudeFn({ model, system, messages, max_tokens, output_config });
  return result.data;
}

/** Anropar med structured outputs och returnerar det parsade objektet. */
export async function callClaudeJSON({ model, system, messages, max_tokens, schema }) {
  const data = await callClaude({
    model, system, messages, max_tokens,
    output_config: { format: { type: 'json_schema', schema } },
  });
  // Schemat garanterar giltig JSON, men bara om modellen fick skriva färdigt.
  // Slår den i taket kommer texten avhuggen och JSON.parse kraschar med ett
  // obegripligt syntaxfel i stället för att peka ut den riktiga orsaken.
  if (data.stop_reason === 'max_tokens') {
    throw new Error(
      `svaret klipptes av vid max_tokens (${max_tokens}) – innehållet var för stort`
    );
  }
  const text = data.content?.find(b => b.type === 'text')?.text || '';
  if (!text) throw new Error('modellen returnerade inget textsvar');
  return JSON.parse(text);
}
